module.exports = __webpack_public_path__ + "static/media/notfound.e15784be.png";